import React, { Component, Fragment } from "react";
import "./CandidateInterviewInvite.css";
import InterviewDetails from "../../../components/Client/ClientInterviewSchedular/InterviewDetails/InterviewDetails";
import SelectedDateTime from "../../../components/Client/ClientInterviewSchedular/SelectedDateTime/SelectedDateTime";
import Button from "../../../components/UI/Button/Button";
import MediaQuery from "react-responsive";
import ConsoleLog from "../../../hoc/ConsoleLog/ConsoleLog";
import axios from "../../../services/axios-service";
import moment from "moment";
import CandidateInterviewDecision from "../../../components/Candidate/CandidateInterviewDecision/CandidateInterviewDecision";
// import { runInThisContext } from "vm";
import Modal from "../../../components/UI/Modal/Modal";

class CandidateInterviewInvite extends Component {
  state = {
    confirmButtonDisabled: true,
    client_interview_location: "",
    client_interview_type: "",
    client_interview_duration: "",
    client_interview_candidate_status: "",
    company_name: "",
    job_name: "",
    slots: [],
    slot_time: "",
    token: "",
    noneSelected: false,
    datesSelectable: true,
    selectedDateTime: "",
    data: {
      status: "",
      slot: "",
      reference: ""
    },
    responseStatus: "",
    responseSection: false,
    slotTakenModal: false
  };

  componentDidMount() {
    let token = "";
    let searchArray = [];
    if (this.props.location.search) {
      searchArray = this.props.location.search.split("?reference=");
      token = searchArray[1];
    }

    axios
      .get("galaxy/interview/candidate/" + token)
      .then(resp => {
        if (resp.data) {
          let info = resp.data;
          if (info.client_interview_candidate_status) {
            this.setState({
              client_interview_location: info.client_interview_location,
              client_interview_type: info.client_interview_type,
              client_interview_duration: info.client_interview_duration,
              company_name: info.company_name,
              job_name: info.job_name,
              token: token,
              client_interview_candidate_status: info.client_interview_candidate_status
                ? info.client_interview_candidate_status
                : "",
              slot_time: info.slot_time ? info.slot_time : "",
              responseSection: true,
              responseStatus: info.client_interview_candidate_status
                ? info.client_interview_candidate_status
                : ""
            });
          } else {
            this.setState({
              client_interview_location: info.client_interview_location,
              client_interview_type: info.client_interview_type,
              client_interview_duration: info.client_interview_duration,
              company_name: info.company_name,
              job_name: info.job_name,
              slots: info.slots,
              token: token
            });
          }
        }
      })
      .catch(err => ConsoleLog("err", err));
  }

  handleNoneSelection = () => {
    let data = { ...this.state.data };
    data.status = "Rejected";
    data.slot = "";
    data.reference = this.state.token;

    this.setState({
      data,
      noneSelected: true,
      confirmButtonDisabled: false,
      selectedDateTime: ""
    });
  };

  handleDateTimeSelect = slot => {
    let data = { ...this.state.data };
    data.status = "Accepted";
    data.slot = slot.slot;

    this.setState({
      data,
      selectedDateTime: slot,
      noneSelected: false,
      confirmButtonDisabled: false
    });
  };

  handleConfirm = () => {
    this.setState({ confirmButtonDisabled: true });
    let data = { ...this.state.data };
    axios
      .post("galaxy/interview/candidate/" + this.state.token, data)
      .then(resp => {
        if (resp.data) {
          switch (resp.data.message) {
            case "success":
              if (data.status === "Accepted") {
                this.setState({
                  responseStatus: "Accepted",
                  responseSection: true
                });
              } else {
                this.setState({
                  responseStatus: "Rejected",
                  responseSection: true
                });
              }
              break;
            case "unavailable":
              this.setState({ slotTakenModal: true });
              break;
          }
        }
      })
      .catch(err => {
        ConsoleLog("err", err);
      });
  };

  handleTryAgain = () => {
    this.setState({ slotTakenModal: false });
    window.location.reload();
  };

  render() {
    let toDate = "";
    let fromDate = "";
    let durationArray = [];

    const candidateSlots =
      this.state.slots && this.state.slots.length > 0
        ? this.state.slots.map(item => {
            let expired = false;

            if (this.state.client_interview_duration === "30 mins") {
              fromDate = moment.utc(item.slot).format("hh:mma");
              toDate = moment
                .utc(item.slot)
                .add(30, "minutes")
                .format("hh:mma");
            } else {
              durationArray = this.state.client_interview_duration.split(" ");
              fromDate = moment.utc(item.slot).format("hh:mma");
              toDate = moment
                .utc(item.slot)
                .add(durationArray[0], "hours")
                .format("hh:mma");
            }

            if (moment(item.slot).isBefore(moment.utc())) {
              expired = true;
            }
            ConsoleLog(
              "slot time",
              moment.utc(item.slot),
              "today",
              moment.utc()
            );

            return {
              date: moment.utc(item.slot).format("ddd D MMMM YYYY"),
              time: fromDate + " - " + toDate,
              slot: item.slot,
              expired
            };
          })
        : [];

    let selectedSlotDetails = "";
    if (this.state.slot_time) {
      if (this.state.client_interview_duration === "30 mins") {
        fromDate = moment.utc(this.state.slot_time).format("hh:mma");
        toDate = moment
          .utc(this.state.slot_time)
          .add(30, "minutes")
          .format("hh:mma");
      } else {
        durationArray = this.state.client_interview_duration.split(" ");
        fromDate = moment.utc(this.state.slot_time).format("hh:mma");
        toDate = moment
          .utc(this.state.slot_time)
          .add(durationArray[0], "hours")
          .format("hh:mma");
      }

      selectedSlotDetails = {
        date: moment.utc(this.state.slot_time).format("ddd D MMMM YYYY"),
        time: fromDate + " - " + toDate,
        slot: this.state.slot_time
      };
    }

    const candidateFilteredSlots =
      candidateSlots.length > 0
        ? candidateSlots.filter(item => item.expired === false)
        : [];

    let allSlotsExpired = false;
    if (candidateSlots.length > 0) {
      if (
        candidateSlots.length ===
        candidateSlots.filter(item => item.expired === true).length
      ) {
        allSlotsExpired = true;
      }
    }

    let candidateInterviewDecision = (
      <CandidateInterviewDecision
        {...this.state}
        allSlotsExpired={allSlotsExpired}
        responseStatus={this.state.responseStatus}
        selectedSlotDetails={selectedSlotDetails}
      />
    );

    return (
      <Fragment>
        {this.state.responseSection ? (
          candidateInterviewDecision
        ) : allSlotsExpired === true ? (
          <CandidateInterviewDecision {...this.state} allSlotsExpired={true} />
        ) : (
          <div>
            {this.state.client_interview_type ? (
              <Fragment>
                <div className="candidate-inteview-container">
                  <div className="candidate-inteview-container-main">
                    <div className="candidate-inteview-job-title-section">
                      <p className="candidate-inteview-job-title">
                        {this.state.client_interview_type} for
                        <span> {this.state.job_name}</span> with
                        <span> {this.state.company_name}</span>
                      </p>
                    </div>
                    <div className="candidate-inteview-details">
                      <InterviewDetails
                        interviewLocation={this.state.client_interview_location}
                        interviewType={this.state.client_interview_type}
                      />
                    </div>
                    <div className="candidate-inteview-date-times">
                      <SelectedDateTime
                        candidateSlots={candidateFilteredSlots}
                        handleDateTimeSelect={this.handleDateTimeSelect}
                        datesSelectable={this.state.datesSelectable}
                        selectedDateTime={this.state.selectedDateTime}
                        fromCandidate={true}
                      />
                    </div>
                    <div className="candidate-inteview-date-times-reject">
                      <h4>None of these dates and times are suitable</h4>
                      <div
                        className={
                          this.state.noneSelected
                            ? "candidate-inteview-reject-button selectedGlow"
                            : "candidate-inteview-reject-button"
                        }
                        onClick={this.handleNoneSelection}
                      >
                        <span>Notify my recruiter to reschedule</span>
                      </div>
                    </div>
                  </div>

                  <MediaQuery query="(min-device-width: 768px)">
                    <div className="candidate-inteview-confirm-section">
                      <div className="candidate-inteview-confirm-button">
                        <Button
                          className={
                            this.state.confirmButtonDisabled
                              ? "candidate-confirm-button disabled"
                              : "candidate-confirm-button"
                          }
                          disabled={this.state.confirmButtonDisabled}
                          onClick={this.handleConfirm}
                        >
                          Confirm
                        </Button>
                      </div>
                    </div>
                  </MediaQuery>
                </div>

                <MediaQuery query="(max-device-width: 769px)">
                  <div className="candidate-inteview-confirm-section">
                    <div className="candidate-inteview-confirm-button">
                      <Button
                        className={
                          this.state.confirmButtonDisabled
                            ? "candidate-confirm-button disabled"
                            : "candidate-confirm-button"
                        }
                        disabled={this.state.confirmButtonDisabled}
                        onClick={this.handleConfirm}
                      >
                        Confirm
                      </Button>
                    </div>
                  </div>
                </MediaQuery>
                <Modal
                  className="slot-taken-modal"
                  show={this.state.slotTakenModal}
                >
                  <p>
                    The time slot that you have chosen is no longer available.
                    Please choose another time.
                  </p>
                  <div className="">
                    <Button
                      className="slot-taken-modal-button"
                      onClick={this.handleTryAgain}
                    >
                      Try Again
                    </Button>
                  </div>
                </Modal>
              </Fragment>
            ) : (
              ""
            )}
          </div>
        )}
      </Fragment>
    );
  }
}

export default CandidateInterviewInvite;



// WEBPACK FOOTER //
// ./src/container/Candidate/CandidateInterviewInvite/CandidateInterviewInvite.js